/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, April 18th 2022, 1:33:16 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";

export const GridList = ({ data, uniqueKey, renderGridItem }) => {
  return (
    <Grid container spacing={3} sx={{ paddingTop: 5 }}>
      {data.map((row, index) => {
        return (
          <Grid item xs={12} md={6} lg={4} xl={3} key={`${row[uniqueKey].toString()}`}>
            {renderGridItem?.(row)}
          </Grid>
        );
      })}
    </Grid>
  );
};
